<div class="d-flex flex-column p-0">
    <a
        *ngFor="let link of items"
        [href]="link.url"
        target="_blank"
        class="d-flex justify-content-between align-items-center p-3 bg-white border rounded text-decoration-none text-secondary mt-2"
    >
        <span>{{ link.label }}</span>
        <i class="pi pi-external-link"></i>
    </a>
</div>
